const NotFound = () => {
  return (
    <div className="notfound">
      <p style={{ textAlign: "center" }}>
        404 | Page Not Found! Go <a href="/">Home</a>
      </p>
    </div>
  );
}

export default NotFound;